import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledCancelOfferQuestion = {
  Title: styled.h1`
    font-size: 28px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
    color: ${Color.DARK};
    margin-bottom: 16px;
  `,
  Subtitle: styled.p`
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 24px;
    color: ${Color.LIGHT};
    text-align: center;

    & strong {
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      color: ${Color.PRIMARY};
    }

    & b {
      color: ${Color.DARK};
      font-weight: 600;
    }
  `,
  ImageContainer: styled.div`
    position: relative;
    margin-bottom: 16px;
    aspect-ratio: 320 / 207;
    & span {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px; /* 114.286% */
      letter-spacing: 0.5px;
      padding: 6px 10px;
      border-radius: 20px;
      position: absolute;
      bottom: 8px;
      text-transform: uppercase;

      &:first-of-type {
        color: ${Color.BLUE_DARK};
        background-color: ${Color.WHITE};
        left: 8px;
        html:dir(rtl) & {
          right: 8px;
          left: unset;
        }
      }

      &:last-of-type {
        color: ${Color.WHITE};
        background-color: ${Color.PRIMARY};
        right: 8px;
        html:dir(rtl) & {
          right: unset;
          left: 8px;
        }
      }
    }

    & > img {
      html:dir(rtl) & {
        transform: scaleX(-1);
      }
    }
  `,
  ImageCaption: styled.p`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    color: ${Color.LIGHT};
    text-align: center;
    margin-bottom: 24px;
  `,
  ExclusiveOffer: styled.p`
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    color: ${Color.LIGHT};
    text-align: center;
    margin-bottom: 24px;
    line-height: 20px;

    & strong {
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      color: ${Color.PRIMARY};
    }
  `,
}
